export enum ComponentType {
  FieldControlEditComponent = 0,
  FieldControlViewComponent,
  FieldControlConfigComponent,

  FieldBlockEditComponent = 10,
  FieldBlockViewComponent,

  WidgetComponent = 20,
  WidgetConfigComponent,

  EntryTemplateEditComponent = 30,
  EntryTemplateViewComponent,
  EntriesListTemplateViewComponent,
}
